module.exports = "../fonts/telegram_registration.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telegram_registration.svg
// module id = 93
// module chunks = 0